import apiClient from '@/services/axios'
import { getRoutingSessionId } from '@/services/routing-session'

function withRoutingSession(payload) {
  const sessionId = getRoutingSessionId()
  if (!sessionId) return payload
  return { ...payload, routingSessionId: sessionId }
}

export async function getStops(query) {
  return apiClient.get('/stops', {
    params: query,
  })
}

export async function createStop(stop) {
  return apiClient.post('/stops', withRoutingSession(stop))
}

export async function assignStudentToManualStop(payload) {
  return apiClient.post(`/stops/assign-student-to-manual-stop`, payload)
}

export async function unassignStudentFromRouting(payload) {
  return apiClient.post(`/stops/unassign-student-from-routing`, payload)
}

export async function unassignStudentsFromRouting(payload) {
  return apiClient.post(`/stops/unassign-students-from-routing`, payload)
}

// Every PATCH that carries the session id makes the backend rewrite the whole
// routing version snapshot. Callers that fire a burst of PATCHes can opt out
// on all but the last one so the snapshot is written once.
export async function updateStop({ id, ...stop }, { withSession = true } = {}) {
  const body = _.omit(stop, 'students')
  return apiClient.patch(
    `/stops/${id}`,
    withSession ? withRoutingSession(body) : body,
  )
}

export async function deleteStop(id) {
  return apiClient.delete(`/stops/${id}`)
}
